import api from "../api";

const url = "/base-data";

export default {
  getCurrencies() {
    return api.get(`${url}/currencies/`);
  },
  getContactMethods() {
    return api.get(`${url}/contact-methods/`);
  },
  getPaymentConditions() {
    return api.get(`${url}/payment-conditions/`);
  },
  getLanguages(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/languages/` + query);
  },
  getAgeGroups() {
    return api.get(`${url}/age-groups/`);
  },
  getCategories(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/categories/` + query);
  },
  getCountries(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/countries/` + query);
  },
  getOccupations() {
    return api.get(`${url}/jobs/`);
  },
  getPeriodicalTypes(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/periodical-types/` + query);
  },
  getSecurityQuestions() {
    return api.get(`${url}/security-questions/`);
  },
  getDeliveryTypes() {
    return api.get(`${url}/shipping-methods/`);
  },
  getSubscriptionTypes() {
    return api.get(`${url}/subscription-types/`);
  },
  getClaimSubjects(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/claim-subjects/` + query);
  },
  getClaimPriorities(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/claim-priorities/` + query);
  },
  cancelReasons() {
    return api.get(`${url}/cancel-reason/`);
  },
  getExchangeRates(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/exchange-rate/` + query);
  },
};
